import { Controller } from "@hotwired/stimulus";

/**
 * Debounces the inbox search box and submits its wrapping GET form, letting the
 * server filter the list (Turbo replaces the results frame). Replaces the old
 * client-side filter, which only matched entries already loaded in the DOM and
 * so missed everything past the first paginated page.
 */
export default class extends Controller<HTMLFormElement> {
  private timeout?: ReturnType<typeof setTimeout>;

  submit(): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.element.requestSubmit(), 250);
  }

  // Mirrors the search into the URL once the results frame has loaded. Turbo's
  // own turbo-action=replace would do this by promoting the frame load to a
  // page visit, but that visit is proposed a tick after the frame renders and
  // cancels any navigation started in between, so a row tapped right after
  // typing was lost.
  frameLoaded(event: Event): void {
    const frame = event.target as HTMLElement & { src: string };
    if (frame.id !== this.element.dataset.turboFrame || !frame.src) return;
    history.replaceState(history.state, "", frame.src);
  }

  disconnect(): void {
    clearTimeout(this.timeout);
  }
}
